<template>
    <div>
        <div class="legend-container">
            <div
                v-for="({ initials, definition }, index) in legends"
                :key="`${definition + index}`"
            >
                <span>
                    <span :style="updateColorLegends(initials)"
                        >{{ `${initials}` }}
                    </span>
                    {{ `= ${definition}` }}
                </span>
            </div>
        </div>
        <b-card-group class="compact-container">
            <b-card
                class="compact-content"
                v-for="block in blocks"
                :key="block.id"
                v-show="block.value"
            >
                <CardCompact :block="block" />
            </b-card>
        </b-card-group>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { CardCompact } from './components'
export default {
    name: 'CompactMode',
    components: {
        CardCompact,
    },
    computed: {
        ...mapState('strategy', {
            blocks: (state) => state.blocks,
        }),
    },
    data() {
        return {
            legends: [
                {
                    initials: 'P',
                    definition: this.$t('strategy.compactMode.priority'),
                },
                {
                    initials: this.$t('strategy.compactMode.challenge.sigla'),
                    definition: this.$t('strategy.compactMode.challenge.name'),
                },
                {
                    initials: 'H',
                    definition: this.$t('strategy.compactMode.horizon'),
                },
            ],
        }
    },
    methods: {
        updateColorLegends(params) {
            return params == 'P'
                ? 'color: #E7A42F'
                : params == this.$t('strategy.compactMode.challenge.sigla')
                ? 'color: #009ADA'
                : 'color: #6E6E6E'
        },
    },
}
</script>

<style lang="sass" scoped>
.legend-container
    margin-top: 1rem
    display: flex
    column-gap: .8rem
    margin-left: 2rem
    color: #6E6E6E
.compact-container
    display: grid
    grid-template-columns: repeat(3, 1fr)
    gap: 1rem
    padding: 1rem
    .compact-content
        min-width: 450px
        width: 100%
        border: 1px solid rgba(0, 0, 0, .1)
        border-radius: 5px
@media screen and (max-width: 1500px)
    .compact-container
        grid-template-columns: repeat(2, 1fr)
@media screen and (max-width: 1000px)
    .compact-container
        grid-template-columns: 1fr
        .compact-content
            min-width: 100%
</style>
